import { Button } from "$components/button/button";
import { styled } from "@material-ui/core";
import React from "react";

const Footer = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "flex-end",
  gap: theme.spacing(2),
}));

/**
 * The footer for a dialog.
 *
 * The submit button will only show if `submitLabel` is provided.
 * The cancel button will only show if `cancelLabel` and `onCancel` are provided.
 *
 * @param submitLabel The label for the submit button.
 * @param onSubmit The callback for the submit button.
 * @param cancelLabel The label for the cancel button.
 * @param onCancel The callback for the cancel button.
 * @param children The content of the footer. If supplied, the buttons will not show.
 *
 * All other props are passed to the root element.
 */
export const DialogFooter: FC<
  {
    submitLabel?: string;
    onSubmit?: () => void;
    submitLoading?: boolean;
    submitDisabled?: boolean;
    cancelLabel?: string;
    onCancel?: () => void;
  } & React.ComponentProps<"div">
> = ({
  submitLabel,
  onSubmit,
  submitLoading,
  submitDisabled,
  cancelLabel,
  onCancel,
  ...restProps
}) => {
  return (
    <Footer {...restProps}>
      {restProps.children || (
        <>
          {cancelLabel && onCancel && (
            <Button variant="text" onClick={onCancel}>
              {cancelLabel}
            </Button>
          )}
          {submitLabel && (
            <Button
              type="submit"
              onClick={onSubmit}
              loading={submitLoading}
              disabled={submitDisabled}
            >
              {submitLabel}
            </Button>
          )}
        </>
      )}
    </Footer>
  );
};
